import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { Logo } from '../../shared';

export default function Footer() {
  const { t } = useTranslation();

  const navigation = useMemo(
    () =>
      [
        {
          to: '/tos',
          text: t('Terms & Conditions'),
        },
        {
          to: '/privacy',
          text: t('Privacy Policy'),
        },
        {
          to: 'https://forms.gle/fxj2NknWXY6SdT149',
          text: t('Project Application'),
        },
        {
          to: '/data-remove-form',
          text: t('Data Remove Form'),
        },
        {
          to: '/cookies',
          text: t('Cookie Policy'),
        },
      ].map((item) => ({
        ...item,
        className: ({ isActive }: { isActive: boolean }) =>
          classNames(
            'font-medium transition-color',
            isActive ? 'text-blue-500' : 'text-gray-700 dark:text-[#FFDA68]',
          ),
      })),
    [],
  );

  const socials = useMemo(
    () => [
      {
        href: 'https://twitter.com/midle_official',
        name: 'twitter',
        icon: <i className='icon-twitter text-lg pr-1' />,
      },
      {
        href: 'https://www.youtube.com/channel/UCUOZ2DNTBm9SsWIfuIVnxzg',
        name: 'youtube',
        icon: <i className='icon-youtube text-lg' />,
      },
      {
        href: 'https://discord.com/invite/cjtZqsRfhP',
        name: 'discord',
        icon: <i className='icon-discord pr-1 text-lg' />,
      },
    ],
    [],
  );

  return (
    <footer className='mt-auto w-full py-12 lg:py-12 px-4 sm:px-6 lg:px-8 mx-auto bg-[#EDF3FF] dark:bg-[#202020]'>
      <div className='text-center'>
        <div className='flex justify-center mx-auto'>
          <Link className='' to='/' aria-label={t('Brand')}>
            <Logo />
          </Link>
        </div>

        <div className='flex flex-col gap-y-4 gap-x-0 mt-6 justify-center sm:flex-row sm:items-center sm:gap-y-0 sm:gap-x-6 text-sm !text-red-500'>
          {navigation.map(({ text, ...item }) => (
            <NavLink
              rel={item.to.startsWith('http') ? 'noopener noreferrer' : undefined}
              target={item.to.startsWith('http') ? '_blank' : undefined}
              {...item}
              key={item.to}
            >
              {text}
            </NavLink>
          ))}
        </div>

        <div className='mt-6 space-x-5'>
          {socials.map((i) => (
            <a
              key={i.name}
              className='w-10 h-10 inline-flex justify-center items-center border border-gray-700 dark:border-[#FFDA68] rounded-full focus:outline-none dark:text-[#FFDA68] transition hover:bg-gray-100 dark:hover:bg-[#FFDA68]/10'
              href={i.href}
              title={i.name}
            >
              {i.icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
